import React, { useRef, useEffect } from "react";
//import global from 'images/map-selector/global-map.png';
import 'styles/controls/RegionSelect.sass';
import { useSelector, useDispatch } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import { fetchArea } from 'js/fetchers'



export default function RegionSelect() {
  const dispatch = useDispatch();
  const menu = useRef()
  const tri = useRef()
  const zones = useSelector((state) => state.zones);
  const zone = useSelector((state) => state.zone);
  const area = useSelector((state) => state.geoArea);
  const images = require.context('images/map-selector')
  const geoAreas = require.context('resources/zones',false, /\.json$/, 'lazy')



  useEffect(() => { 
    console.log('render RegionSelect')
  });


  //useOnUpdate(() => { 
  //  changeZone('global')
  //}, [zones]);

  function changeZone(zone){
    var callback = ([features,data]) => dispatch({ type: 'SET_ZONE', payload: {zone:zone, allData: data, features: features.features}})
    fetchArea(zone, zones[zone].id, callback)
  }

  function toggleRegion(ev) {
    console.log(document.getElementById('setMinHeight').scrollHeight)
    var aux = document.getElementById('setMinHeight').scrollHeight;
    if (menu.current.style.display == 'block'){
      closeMenus()
      tri.current.classList.add('bounce')
    }
    else{
      closeMenus()
      menu.current.style.display = 'block'
      tri.current.classList.remove('bounce')
      console.log(document.getElementById('setMinHeight').scrollHeight)
      if (document.getElementById('setMinHeight').scrollHeight > aux)
        document.getElementById("setMinHeight").style["min-height"] = (document.getElementById('setMinHeight').scrollHeight + 10)+ "px"
    }
    ev.stopPropagation()
  }

  function overReg(){
    if (menu.current.style.display != 'block')
      tri.current.classList.add('bounce')
  }

  function outReg(){
    tri.current.classList.remove('bounce')
  }

  function closeMenus(){
    for (var item of document.getElementsByClassName('selMenu')){
      item.style.display = 'none'
    }
    document.getElementById("setMinHeight").style["min-height"] = "0px"
  }


  return (
    <div id="regionSelect">
      <div id="regionBox" onClick={toggleRegion} onMouseOver={overReg} onMouseOut={outReg}> 
        <img src={zone?images('./'+zone+'-map.png'):''}/>
        <div className="test">
          <span>{zone?zones[zone].fullname:''}</span>
          <span className="area">{area}</span>
        </div>
        <div id="triReg">
          <svg ref={tri} id="triSvg" x="0px" y="0px" viewBox="-100 -100 1200 1200">
            <g><path d="M37.8,336.3c0,0-55.2-41.1-10.1-93.8C53.2,219.7,67.3,224,67.3,224h173.3h685.7c0,0,30.7-0.9,46,19c15.3,19.9,35.9,55.8-12,93.2c-53,51.5-413.7,413.7-413.7,413.7l-11.7,10.1c0,0-36.2,39.3-77.6-4.3C414.1,713.4,37.8,336.3,37.8,336.3z"/></g>
          </svg>
        </div>
      </div>
      <div className="regionOptsCont">
        <div ref={menu} id="regionOpts" className="selMenu">
          {Object.keys(zones).filter(z => z!= zone).map((z) => (
            <div className="regionOpt" onClick={() => {changeZone(zones[z].name) }}>
              <img src={images('./'+zones[z].name+'-map.png')} />
              <div><span>{zones[z].fullname}</span></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
